export const DriverType = {
  MAIN: 'MAIN',
  SECOND: 'SECOND',
}
